/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Announcement,
    AnnouncementFromJSON,
    AnnouncementToJSON,
} from '../models';

export interface AnnouncementCreateRequest {
    announcement?: Announcement;
}

export interface AnnouncementGetRequest {
    includeFuture?: boolean;
}

export interface AnnouncementUpdateRequest {
    id: number;
    announcement?: Announcement;
}

/**
 * 
 */
export class AnnouncementApi extends runtime.BaseAPI {

    /**
     */
    async announcementCreateRaw(requestParameters: AnnouncementCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Announcement>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Announcement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnnouncementToJSON(requestParameters.announcement),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnnouncementFromJSON(jsonValue));
    }

    /**
     */
    async announcementCreate(requestParameters: AnnouncementCreateRequest, initOverrides?: RequestInit): Promise<Announcement> {
        const response = await this.announcementCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async announcementGetRaw(requestParameters: AnnouncementGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Announcement>>> {
        const queryParameters: any = {};

        if (requestParameters.includeFuture !== undefined) {
            queryParameters['includeFuture'] = requestParameters.includeFuture;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Announcement`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnnouncementFromJSON));
    }

    /**
     */
    async announcementGet(requestParameters: AnnouncementGetRequest, initOverrides?: RequestInit): Promise<Array<Announcement>> {
        const response = await this.announcementGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async announcementUpdateRaw(requestParameters: AnnouncementUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling announcementUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Announcement/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AnnouncementToJSON(requestParameters.announcement),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async announcementUpdate(requestParameters: AnnouncementUpdateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.announcementUpdateRaw(requestParameters, initOverrides);
    }

}
